import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { FlightShopActions } from "@b2bportal/core-flights";
import { PackageFlightReturnPage } from "@b2bportal/core-packages";
import {
  PackageNavigationFlow,
  PackageSteps,
  PageRouteContainer,
} from "@b2bportal/core-utilities";
import { PackagesFlightSlotProvider } from "../slots/flightSlots";
import { usePackageFlightReturnPage } from "./hooks/usePackageFlightReturnPage";
import { useRbcPackageFlightReturnPageRoute } from "./hooks/usePackageFlightReturnPageRoute";

export const RbcPackageFlightReturnPageRoute = () => {
  const dispatch = useDispatch();

  const { fullRouteWithCurrentQueryParams } =
    PackageNavigationFlow.useGetStepRoute(PackageSteps.HOTEL_SHOP);

  // ReturnPage derives the slice index it renders from multicityShopStep, so
  // it has to be 1 (return flight) here. The non-packages ReturnPageRoute sets
  // this; the packages flow has its own route, so it must set it too or the
  // return cards render the outbound slice's details and fare brand name.
  useEffect(() => {
    dispatch(FlightShopActions.setMulticityShopStep(1));
  }, [dispatch]);

  return (
    <PackagesFlightSlotProvider>
      <PageRouteContainer
        route={{
          useValidateRouteProps: useRbcPackageFlightReturnPageRoute,
          errorRedirectPath: fullRouteWithCurrentQueryParams,
        }}
        container={{
          useDeriveViewProps: usePackageFlightReturnPage,
          Component: PackageFlightReturnPage,
        }}
      />
    </PackagesFlightSlotProvider>
  );
};
